
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { globalStore, uiStore, configStore } from "@/store/store";
import defensiveCopy from "@/util/defensive-copy";
import { ElementPreset } from "@/types/presets";
import PresetsList from "./PresetsList.vue";
import AddPreset from "./AddPreset.vue";
import PanelHeader from "@/components/Reusable/Util/PanelHeader.vue";

// @ts-ignore
import draggable from "vuedraggable";
import BrowseModeToggle from "@/components/BrowseMode/BrowseModeToggle.vue";
import PanelHeaderButton from "@/components/Reusable/Util/PanelHeaderButton.vue";
import PresetsPanelHistoryViewMode from "@/components/Settings/ElementPresets/PresetsPanelHistoryViewMode.vue";
import ImportExportPresets from "@/components/Settings/ElementPresets/ImportExportPresets.vue";
import AlertBox from "@/components/Reusable/CustomInputs/AlertBox.vue";
import FreeModeAlertForPresets from "@/components/Subscription/FreeModeAlertForPresets.vue";

@Component({
  components: {
    FreeModeAlertForPresets,
    AlertBox,
    PresetsPanelHistoryViewMode,
    PanelHeaderButton,
    BrowseModeToggle,
    draggable,
    PresetsList,
    AddPreset,
    PanelHeader,
    ImportExportPresets
  }
})
export default class ManagePresets extends Vue {
  get viewMode() {
    return uiStore.panelState.presetsPanelActiveViewMode;
  }
  toggleViewMode() {
    uiStore.setPanelState({
      ...uiStore.panelState,
      presetsPanelActiveViewMode:
        this.viewMode === "controls" ? "history" : "controls"
    });
  }

  get presets() {
    return globalStore.presets;
  }

  get isAddPresetEnabled() {
    return configStore.isExperimentEnabled("design-presets-add");
  }

  get isImportExportEnabled() {
    return configStore.isExperimentEnabled("design-presets-import-export");
  }

  updatePresets(newPresets: ElementPreset[]) {
    globalStore.setPresets(defensiveCopy(newPresets));
  }
}
